import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
@Injectable()
export class AutoWithdrawService {
    api_url: string = environment.apiEndPoint;

    constructor(private http: HttpClient) { }
    getToken() {
        return localStorage.getItem(environment.TOKEN_SECRET);
    }
    getAutoWithdraw(filter: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'get-auto-withdraw', filter, configs)
    }
    saveAutoWithdraw(updateData: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'save-auto-withdraw', updateData, configs)
    }
    updateAutoWithdrawToggle(updateData: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'update-auto-withdraw-toggle', updateData, configs)
    }
    getAutoWithdrawTransactions(data: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'get-auto-withdraw-transactions', data, configs)
    }
}


// WEBPACK FOOTER //
// ./src/app/services/autowithdraw.service.ts